import './ccf-directory-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfDirectoryIconProps extends SvgIconProps {
  bgColor?:string;
}

/**
 * CcfDirectoryIcon used to disply directory icon in the navigation panel & app space
 * @param props - CcfDirectoryIconProps
 * @example -- <CcfDirectoryIcon />
 */
export function CcfDirectoryIcon(props: CcfDirectoryIconProps) {
  return (
    <SvgIcon {...props}>
      <g id="Directory" clipPath="url(#clip-Directory)">
      <rect width="20" height="20" fill={ props.bgColor? props.bgColor: "#fff"}/>
      <g id="Group_118160" data-name="Group 118160" transform="translate(-2 24018)">
          <rect id="Rectangle_80238" data-name="Rectangle 80238" width="44" height="44" rx="2" transform="translate(0 -24020)" fill="#f2f2f2" opacity="0"/>
          <g id="Group_118158" data-name="Group 118158" transform="translate(2 -24017.783)">
            <g id="Rectangle_80239" data-name="Rectangle 80239" transform="translate(0 -0.214)" fill="#fff" stroke="#707070" strokeWidth="1" opacity="0">
              <rect width="20.212" height="19.997" stroke="none"/>
              <rect x="0.5" y="0.5" width="19.212" height="18.997" fill="none"/>
            </g>
            <path id="Address_Books" data-name="Address Books" d="M15.508,0H3.68a.99.99,0,0,0-1,1v2.87H2.32a1,1,0,0,0,0,2h.36v1.42H2.32V7.279a.99.99,0,0,0-1,1,1,1,0,0,0,1,1h.36V10.7H2.32a1,1,0,0,0,0,2h.36v1.42H2.32a1,1,0,0,0,0,2h.36v2.87h0a1,1,0,0,0,1,1H15.508a3.171,3.171,0,0,0,3.17-3.17V3.16h0a3.164,3.164,0,0,0-3.17-3.17Zm1.17,16.828h0A1.191,1.191,0,0,1,15.508,18H4.68v-1.87H5a1,1,0,0,0,0-2H4.68v-1.42H5a1,1,0,1,0,0-2H4.68V9.289H5a1,1,0,1,0,0-2H4.68V5.869H5a1,1,0,0,0,0-2H4.68V2H15.508a1.178,1.178,0,0,1,1.17,1.17ZM13.438,9.9h0a2.731,2.731,0,0,0,.43-1.46h0a2.74,2.74,0,1,0-5.479,0h0a2.568,2.568,0,0,0,.43,1.46h0A4.063,4.063,0,0,0,7,13.3h-.01a1,1,0,0,0,1,1h6.219a1,1,0,0,0,1-1h0a4.127,4.127,0,0,0-1.78-3.4Zm-3-1.46h0a.74.74,0,1,1,1.48,0h0a.74.74,0,0,1-1.48,0ZM9.269,12.3h0a2.1,2.1,0,0,1,3.71-.01Z" transform="translate(-0.45 -0.206)"/>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}

export default CcfDirectoryIcon;
